import { getNavsInit, getNavsInitCustomerManage } from "@/config/navs";
import { State, Userinfo, nav } from "../interface/common";

const state: State = {
  token: "",
  userinfo: {},
  navArr: getNavsInit(),
  navArrCustomerManage: getNavsInitCustomerManage(),
  currentPower: {
    isApprove: true,
    isBudget: true,
    isPurchase: true,
    isFinancial: true,
    isFinancialList: true,
    isFiscalAnalysis: true,
    isCompany: true,
  },
  badges: [],
  badgeDot: true,
  power: {},
  managePower: {
    isplatform: false, // 工作台查看
    isManager: false, // 管理台查看
    isinsertdepart: false, // 新增部门
    isupdatdepart: false, // 编辑部门
    isdeletedepart: false, // 删除部门
    isinsertuser: false, // 新增人员
    isupdatuser: false, // 编辑人员
    isconnect: false, // 企业交接
    isuserenterprise: false, // 企业分配
  },
  reloadIframe: false,
  OEMInfo: {
    show: false,
    url: "",
    windowTitle: "",
    icoUrl: "",
    Secret: "",
  },
  //默认为客户管理
  tabNum: 4,
  userTree: {},
  customerAuths: {},
  industryToken: "",
};

const mutations = {
  /** 设置token */
  SET_TOKEN(state: State, token: string) {
    state.token = token;
  },
  /** 设置token */
  SET_USERINFO(state: State, userinfo: Userinfo) {
    state.userinfo = userinfo;
  },
  /** 设置徽标 */
  SET_BADGES(state: State, data: any) {
    state.badges = data;
  },
  /**设置权限 */
  SET_POWER(state: State, data: any) {
    state.power = data;
  },
  /** 设置导航 */
  SET_NAVS(state: State, data: any) {
    state.navArr = data;
  },
  /** 设置导航 */
  SET_NAVSCUSTOMERMANAGE(state: State, data: any) {
    state.navArrCustomerManage = data;
  },
  /** 设置模块权限 */
  SET_CURRENT_POWER(state: State, data: any) {
    state.currentPower = data;
  },
  /** 设置管理台权限权限 */
  SET_MANAGE_POWER(state: State, data: any) {
    state.managePower = data;
  },
  /** 刷新IFarme */
  SET_CURRENT_RELOADIFRAME(state: State, data: any) {
    state.reloadIframe = data;
  },
  /** OEM信息 */
  SET_CURRENT_OEMINFO(state: State, data: any) {
    state.OEMInfo = data;
  },
  /** 导航菜单选中值 */
  SET_CURRENT_TABNUM(state: State, data: any) {
    state.tabNum = data;
  },
  /** 用户树 */
  SET_USERTREE(state: State, data: any) {
    state.userTree = data;
  },
  /** 客户权限 */
  SET_CUSTOMERAUTHS(state: State, data: any) {
    state.customerAuths = data;
  },
  /** 设置token */
  SET_INDUSTRYTOKEN(state: State, token: string) {
    state.industryToken = token;
  },
};

const getters = {
  /** 获取token */
  getToken: (state: State) => state.token,
  /** 获取用户信息 */
  getUserinfo: (state: State) => (key?: string) => key ? state.userinfo[key] || "" : state.userinfo,
  /** 获取导航列表 */
  getNavArr: (state: State) => state.navArr,
  getNavArrCustomerManage: (state: State) => state.navArrCustomerManage,
  /** 获取权限列表*/
  getPower: (state: State) => state.power,
  /** 获取徽标 */
  getBadges: (state: State) => state.badges,
  /** 获取模块权限 */
  getCurrentPower: (state: State) => state.currentPower,
  /** 获取管理台权限 */
  getManagePower: (state: State) => state.managePower,
  /** 刷新IFRAME */
  getReloadIframe: (state: State) => state.reloadIframe,
  /** OEM信息 */
  getOEMInfo: (state: State) => state.OEMInfo,
  /** OEM信息 */
  getTabNum: (state: State) => state.tabNum,
  /** 用户树 */
  getUserTree: (state: State) => state.userTree,
  /** 客户权限 */
  getCustomerAuths: (state: State) => state.customerAuths,
  /** 获取token */
  getIndustryToken: (state: State) => state.industryToken,
};
const actions = {
  /** 设置徽标 */
  setBadges({ commit }: any, data: any) {
    commit("SET_BADGES", data);
  },
  setPower({ commit }: any, data: any) {
    commit("SET_POWER", data);
  },
  setNavs({ commit }: any, data: nav[]) {
    commit("SET_NAVS", data);
  },
  setNavsCustomerManage({ commit }: any, data: nav[]) {
    commit("SET_NAVSCUSTOMERMANAGE", data);
  },
  setCurrentPower({ commit }: any, data: any) {
    commit("SET_CURRENT_POWER", data);
  },
  setCurrentReloadIframe({ commit }: any, data: any) {
    commit("SET_CURRENT_RELOADIFRAME", data);
  },
  setCurrentOEMInfo({ commit }: any, data: any) {
    commit("SET_CURRENT_OEMINFO", data);
  },
  setCurrentTabNum({ commit }: any, data: any) {
    commit("SET_CURRENT_TABNUM", data);
  },
  setUserTree({ commit }: any, data: any) {
    commit("SET_USERTREE", data);
  },
  setCustomerAuths({ commit }: any, data: any) {
    commit("SET_CUSTOMERAUTHS", data);
  },
};
export default {
  state,
  mutations,
  getters,
  actions,
};
